export default __webpack_public_path__ + "static/media/Frame 145.217cf4df.svg";